import React, { useEffect, useRef, useState } from "react"

type AppUpdateDetail = {
  updateAvailable?: boolean
}

export function UpdateToast() {
  const [open, setOpen] = useState(false)
  const dismissTimerRef = useRef<number | null>(null)
  const [mode, setMode] = useState<"available" | "refreshing">("available")

  useEffect(() => {
    const scheduleDismiss = () => {
      if (dismissTimerRef.current != null) {
        window.clearTimeout(dismissTimerRef.current)
        dismissTimerRef.current = null
      }
      dismissTimerRef.current = window.setTimeout(() => {
        setOpen(false)
      }, 5000) as unknown as number
    }

    const handleUpdateEvent = (ev: Event) => {
      const detail = (ev as CustomEvent<AppUpdateDetail>)?.detail
      if (!detail?.updateAvailable) return
      setMode("refreshing")
      setOpen(true)
      scheduleDismiss()
    }

    window.addEventListener("app:update", handleUpdateEvent as EventListener)

    return () => {
      window.removeEventListener("app:update", handleUpdateEvent as EventListener)
      if (dismissTimerRef.current != null) {
        window.clearTimeout(dismissTimerRef.current)
        dismissTimerRef.current = null
      }
    }
  }, [])

  if (!open) return null

  const handleUpdateNow = () => {
    setOpen(false)
    try {
      sessionStorage.setItem("app_updated", "true")
    } catch {
    }
    const fn = (window as any).__PWA_UPDATE_SW__
    if (typeof fn === "function") {
      fn(true)
      return
    }
    window.location.reload()
  }

  return (
    <div
      className={[
        "fixed left-3 right-3 z-[100]",
        "bottom-[calc(env(safe-area-inset-bottom)+12px)]",
        "sm:left-auto sm:right-4 sm:max-w-sm",
      ].join(" ")}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white/95 px-4 py-3 shadow-lg backdrop-blur">
        <div className="min-w-0">
          <div className="text-sm font-semibold text-slate-900">
            {mode === "refreshing" ? "New update available – refreshing..." : "New version available"}
          </div>
        </div>
        {mode !== "refreshing" && (
          <button
            type="button"
            onClick={handleUpdateNow}
            className="shrink-0 rounded-lg bg-slate-900 px-3 py-2 text-sm font-semibold text-white hover:bg-slate-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2"
          >
            Update now
          </button>
        )}
      </div>
    </div>
  )
}
